
<meta name="viewport" content="width=device-width, initial-scale=1">
<form #f="ngForm" *ngIf="loginOrSignUp !== null" id='signUpContainer' class='signUpContainer'>
	<div *ngIf="loginOrSignUp === 'signUp'" class='SignUpInnerContainer'>
		<h1 [@item] id='registerTitle' class='registerTitle'>{{signUpLabel}}</h1>
		<p  [@item] class="errorFont">{{errorView}}</p>
		<input [@item] id='firstname' class='signUpInputs' type='text' name='Fname' placeholder={{config?.authFirstName}} [(ngModel)]="firstname">
		<input [@item] id='lastname' class='signUpInputs' type='text' name='Lname' placeholder={{config?.authLastName}} [(ngModel)]="lastname">
		<input *ngIf="country != 'United States' && country != 'Canada'" [@item] id='city' class='signUpInputs' type='text' name='city' placeholder={{config?.authCity}} [(ngModel)]="city">
		<!-- <input *ngIf="country == 'United States'|| country == 'Canada'" [@item] id='phone' class='signUpInputs' type='text' name='phone' placeholder={{config?.authPhone}} [(ngModel)]="phone"> -->
		<input *ngIf="country == 'United States' || country == 'Canada'" [@item] id='zipCode-1231' class='signUpInputs' type='text' name='zipCode' placeholder={{config?.authZip}} [(ngModel)]="zipcode">
		<!-- <br *ngIf="country == 'United States' || country == 'Canada'"/>		 -->
		<select [@item] name="country" id="country" [(ngModel)]="country">
			<option *ngFor="let c of countries" value="{{c.name}}">{{c.name}}</option>
		  </select>
		<input [@item] id='emailRegister'  class='signUpInputs' type='email' name='email' placeholder={{config?.authEmail}} [(ngModel)]="email">
		<input [@item] id="passwordRegister" class="signUpInputs" type="password" name="pword" placeholder={{config?.authPassword}} [(ngModel)]="password">
		<input [@item] *ngIf='showEntity' id='entityId' class='signUpInputs' type='text' name='sign-up-code' placeholder={{config?.authChurchCode}}  [(ngModel)]="entityId">
		<p [@item] *ngIf='!showEntity' id='gotoLogin' class='icon textButton' (click)='toggleEntity()'>{{config?.authAddChurch}}</p>
		<input [@item] id='emailConf' type='email' name=emailConf class="confirmation"  [(ngModel)]=emailConf placeholder={{config?.authEmailConf}}>
		<input [@item] id='passwordConf' type='password' name=passwordConf class="confirmation"  [(ngModel)]=passwordConf placeholder={{config?.authPasswordConf}}>
		<p style="font-size: 8pt">{{config?.authDisclaimer}}</p>
		<div [@item] class=buttonFlex>
		<div [@item] id='submitRegister' class=button (click)='signUpWithEmailAndPassword()'>{{config?.authRegister}}</div>
		<div [@item] id='cancelRegistration' class='button' (click)='close()'style='background-color: grey'>{{config?.authCancel}}</div>
		</div>
		<p [@item] id='gotoLogin' class='icon textButton' (click)='toLogin()'>{{config?.authToLogin}}</p>
		

	</div>


	<div *ngIf="loginOrSignUp === 'login'" class="SignUpInnerContainer">
		<h1  [@item] *ngIf="forgotPassword === false" id="loginTitle" class="registerTitle" style="position: relative; margin-top:10px;">{{loginLabel}}</h1>
		<p   [@item] id="loginErrorMessage" class="errorFont">{{errorView}}<p>
		<h1  [@item] *ngIf="forgotPassword === true" id="loginTitle" class="registerTitle" style="position: relative; margin-top:10px;">{{config?.authForgotPassword}}</h1>
		<input id="emailLogin" class="signUpInputs" type="email" name="email" placeholder={{config?.authEmail}} [(ngModel)]="email">
		<div [@item] *ngIf="forgotPassword === true" class=button (click)="resetPassword()" >{{config?.authResetPassword}}</div>
		<input 
		[@item] *ngIf="forgotPassword === false"
			id="passwordLogin"
			class="signUpInputs" 
			type="password" 
			name="pword" 
			placeholder={{config?.authPassword}} 
			[(ngModel)]="password">
		<p [@item] *ngIf="forgotPassword === true" class=icon (click)="forgotPassword = false">{{config?.authKnownPassword}}</p>
		<div class=buttonFlex>
			<div [@item] *ngIf="forgotPassword === false" id="submitLogin" class=button (click)="loginWithEmailAndPassword()">{{config?.navLogin}}</div>
			<div [@item] *ngIf="forgotPassword === false" id="cancelLogin" class=button (click)="close()" style="background-color: grey" >{{config?.authCancel}}</div>
		</div>
		<p [@item] *ngIf="forgotPassword === false" id="gotoSignUp" class="icon textButton"  (click)="toSignUp()">{{config?.authToRegister}}</p>
		<p [@item] *ngIf="forgotPassword === false" class="icon textButton" (click)="forgotPassword = true">{{config?.authForgotPassword}}</p>			
	</div>
		
</form>


